export default {"src":"/_next/static/media/CaretRight.5ef7594d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};